import {
  Button,
  Card,
  Skeleton,
  DatePicker,
  Spin,
  Checkbox,
  ConfigProvider,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import {
  formatDateTime,
  generatedISOFormatDateString,
  groupDataByInterval,
  groupDataByIntervalElectrical,
} from "../../../../../../Utils/DateConverstion";

import CustomDrawer from "../../../../../Elements/CustomDrawer";
import CustomSelect from "../../../../../Elements/CustomSelect";
import TreeSelectCustomWithSelectAll from "../../../../../Elements/TreeSelect/TreeSelectCustomWithSelectAll";
import { useSelector } from "react-redux";
import TreeSelectCustom from "../../LiveModule/LiveTrends/LineChart/TreeSelectCustom";
import { APIConstants } from "../../../../../../Common/APIConstants";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import * as echarts from "echarts";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { FilterOutlined } from "@ant-design/icons";
import Empty from "../../../../../CommonScreens/Empty";
const { RangePicker } = DatePicker;
// import dayjs from "dayjs";
const MAX_DAYS = 90;
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import customParseFormat from "dayjs/plugin/customParseFormat";
import SteamTreeSelectCustomWithSelectAll from "../../LiveModule/LiveTrends/LineChart/TreeSelectCustomWithAllSelect";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import minnotra_logo from "../../../../../../Assets/Images/logo2.png";
import NotAuthenticated from "../../../../../CommonScreens/NotAuthenicated";
// Extend plugins
dayjs.extend(weekday);
dayjs.extend(weekOfYear);
dayjs.extend(customParseFormat);
 
const ComparitiveReport = () => {
  const chartRef = useRef(null);
  const { loading, makeRequest,screenNameChecker } = useStoreUpdaterWithAPI();
  const [sectionId, setSectionId] = useState(1);
  const [converterGroupId, setConverterGroupId] = useState(1);
  const [defaultLoad, setDefaultLoad] = useState(true);
  const [selectedMeterIds, setSelectedMeterIds] = useState([]);
  const [skip, setSkip] = useState(true);
  const [open, setOpen] = useState(false); 
  const [isLoading, setIsLoading] = useState(true);
  const [aggregationTime, setAggregationtime] = useState(1);
  const [aggeregationResData, setaggeregationResData] = useState([]);
  const [sectionError, setSectionError] = useState();
  const [converterError, setConverterError] = useState();
  const [meterError, setMeterError] = useState();
  const [paraError, setParaError] = useState();
  const [fromDateError, setFromDateError] = useState();
  const [toDateError, setToDateError] = useState();
  const [aggregationError, setAggregationError] = useState();
  const [flowSectionResData, setflowSectionResData] = useState([]);
  const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
  const [flowGroupDetailsResData, setflowGroupDetailsResData] = useState([]);
  const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState([]);
  const [getFlowSteamGroupMeterResData, setgetFlowSteamGroupMeterResData] =useState([]);
  const [data, setData] = useState([]);
  const [parameter, setParameter] = useState([]);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [loadings, setLoadings] = useState(true);
  const [parameterLenght, setParameterLenght] = useState("");
  const [to, setTo] = useState(null);
  const [from, setFrom] = useState(null);
  const [datesError, setDatesError] = useState(null);
  const [checkedValue, setCheckedValue] = useState(null);
  const [time, setTime] = useState(false);
  const [shift, setShift] = useState(null);
  const [selectedValues, setSelectedValues] = useState(["KWHTOTAL"]);
   const [fromDateObj, setFromDateObj] = useState(dayjs().subtract(1, "hour").format("YYYY-MM-DD HH:mm:ss"));
   const [fromDateString, setFromDateString] = useState(dayjs().subtract(1, "hour").format("YYYY-MM-DD HH:mm:ss"));
   const [toDateObj, setToDateObj] = useState(dayjs().format("YYYY-MM-DD HH:mm:ss"));
   const [toDateString, setToDateString] = useState(dayjs().format("YYYY-MM-DD HH:mm:ss"));
  const [value, setValue] = useState([dayjs().subtract(1, "hour"), dayjs(),]);
  const [excelFromDate,setExcelFromDate]=useState()
  const [excelToDate,setExcelToDate]=useState()
      const [excelImage, setExcelImage] = useState(null);
     const loggedIn = useSelector((state) => state.user);
    // console.log(loggedIn)
    useEffect(()=>{
  
      setExcelImage(loggedIn?.images?.excelImage?`data:image/png;base64,${loggedIn?.images?.excelImage}`:null);
    },[loggedIn])
  // const simulateLoading = (setLoadings) => {
  //   setLoadings(true); 
  //   setTimeout(() => {
  //     setLoadings(false);
  //   }, 2000); // 2 seconds
  // };
  // useEffect(() => {
  //   simulateLoading(setLoadings);
  // }, []);

  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
  const color = useSelector((state) => state.ThemeChange);
  // //console.log(color)

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    // After 1 second, set skipValue to false
    const timeoutId = setTimeout(() => {
      setSkip(false);
    }, 3000);

    // Clear the timeout if the component unmounts or skipValue is set to false
    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_FLOW_SECTION_MASTER_DETAILS}`,
    }).then((res) => {
      // //console.log(res);
      if (res && res.length > 0) {
        setflowSectionResData(res);
      }
    });

    makeRequest({
      type: APIConstants.GET,

      url: `${APIConstants.GET_STEAM_AGGREGATION_PERIOD}`,
    }).then((res) => {
      //console.log(res);
      if (res && res.length > 0) {
        setaggeregationResData(res);
      }
    });

    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.ELECTRICAL_HISTORICAL_PARAMETERS_LIST}`,
    }).then((res) => {
      // //console.log(res);
      if (res && res.length > 0) {
        setParameter(res);
      }
    });
  }, []);
  useEffect(() => {
    if (sectionId == 1) {
      makeRequest({
        type: APIConstants.GET,
        url: `${APIConstants.GET_ELECTRICAL_CONVERTER_DETAILS}`,
      }).then((res) => {
        // //console.log(res);
        if (res && res.length > 0) {
          setgetFlowConverterResData(res);
        }
      });
    } else if (sectionId == 2) {
      makeRequest({
        type: APIConstants.POST,
        url: `${APIConstants.ELECTRICAL_GROUP_NAME}?Module=1`,
      }).then((res) => {
        // //console.log(res);
        if (res && res.length > 0) {
          setflowGroupDetailsResData(res);
        }
      });
    }
  }, [sectionId]);

  useEffect(() => {
    if (converterGroupId && sectionId == 1) {
      makeRequest({
        type: APIConstants.GET,
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.ELECTRICAL_METERS_DETAILS}?ConverterID=${converterGroupId}`,
      }).then((res) => {
        // //console.log(res);
        if (res && res.length > 0) {
          setnsGetFlowConverterResData(res);
               if (defaultLoad) {
            const firstFiveMeters = res
              .slice(0, 5)
              .map((meter) => meter.meterid);

            //console.log(res.map((meter) => meter.meterid));
            //console.log(firstFiveMeters);
            setSelectedMeterIds(firstFiveMeters);
            localStorage.setItem("PlotMeterIds", firstFiveMeters);
            // setSelectedMeterIds(res.map(meter => meter.meterid))
            // localStorage.setItem("LiveTrendsselectedMeterIds", res.map(meter => meter.meterid));
            setDefaultLoad(false);
          }
          // if (defaultLoad){
            
          //   setSelectedMeterIds(res.map((meter) => meter.meterid));
          //   localStorage.setItem(
          //     "PlotMeterIds",
          //     res.map((meter) => meter.meterid)
          //   );
          //   setDefaultLoad(false);
          // }
        } else {
          setnsGetFlowConverterResData([]);
        }
      });
    }

    if (converterGroupId && sectionId == 2) {
      makeRequest({
        type: APIConstants.POST,
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.ELECTRICAL_GROUP_METER_DETAILS}?GroupID=${converterGroupId}&Module=1`,
        // url: `${APIConstants.GET_FLOW_STEAM_GROUP_METER_DETAILS}?GroupID=${converterGroupId}`
      }).then((res) => {
        // //console.log(res);
        if (res && res.length > 0) {
          setgetFlowSteamGroupMeterResData(res);
        } else {
          setgetFlowSteamGroupMeterResData([]);
        }
      });
    }
  }, [converterGroupId]);

  const getFlowSectionList = (flowSectionResData && flowSectionResData) || [];
  const getFlowConverterList =
    (getFlowConverterResData && getFlowConverterResData) || [];
  const flowGroupDetailsList =
    (flowGroupDetailsResData && flowGroupDetailsResData) || [];
  const nsGetFlowConverterList =
    (nsGetFlowConverterResData && nsGetFlowConverterResData) || [];
  const getFlowSteamGroupMeterList =
    (getFlowSteamGroupMeterResData && getFlowSteamGroupMeterResData) || [];
  const aggeregationList = (aggeregationResData && aggeregationResData) || [];

  const handleChangeAggregation = (value) => {
    //console.log(value);
    setAggregationtime(value);
    setToDateError(null);
    setFromDateError(null);
    setValue([null, null]);
    if (value) {
      setAggregationError("");
    }
  };

  const handleChangeSection = (changedValues) => {
    setSectionId(changedValues);
    setConverterGroupId();
    setSelectedMeterIds();
    if (changedValues) {
      setSectionError("");
    }
  };

  const handleChangeConverterGroup = (changedValues) => {
    setConverterGroupId(changedValues);
    // //console.log(changedValues);
    setSelectedMeterIds();
    if (changedValues) {
      setConverterError("");
    }
  };

  const handleMeterChange = (selectedValues) => {
    setSelectedMeterIds(selectedValues);
    if (selectedValues) {
      setMeterError("");
    }
  };

  const onChangeFromDate = (dateString) => {
    // //console.log(dateString);
    // //console.log(new Date(dateString));
    setFromDateString(dateString);
    setFromDateObj(dateString);
    if (dateString) {
      setFromDateError("");
    }
  };

  const onChangeToDate = (dateString) => {
    setToDateString(dateString);
    setToDateObj(dateString);
    if (dateString) {
      setToDateError("");
    }
  };
  function transformChartData(rawData) {
    if (!Array.isArray(rawData)) return { data1: [], data2: [], intervals: [] };

    const uniqueIntervalsMap = new Map(); // Key: `${fromDate}_${toDate}`

    const seriesMap = new Map(); // Key: `${METERNAME}-${PARAM}`, Value: Map of `${from}_${to}` => value

    rawData.forEach((item) => {
      const fromDateObj = new Date(item.FromDate);
      const toDateObj = new Date(item.ToDate);

      const formattedFrom = fromDateObj
        .toLocaleString("en-GB", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        })
        .replace(",", "");

      const formattedTo = toDateObj
        .toLocaleString("en-GB", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        })
        .replace(",", "");

      const intervalKey = `${formattedFrom}_${formattedTo}`;
      if (!uniqueIntervalsMap.has(intervalKey)) {
        uniqueIntervalsMap.set(intervalKey, {
          label: formattedFrom,
          fromDate: formattedFrom,
          toDate: formattedTo,
        });
      }

      Object.keys(item).forEach((key) => {
        if (
          ["FromDate", "ToDate", "SiteName", "SITEID", "MeterId"].includes(key)
        )
          return;
        if (key !== "METERNAME") {
          const meterParamKey = `${item.METERNAME}-${key}`;

          if (!seriesMap.has(meterParamKey)) {
            seriesMap.set(meterParamKey, new Map());
          }

          seriesMap.get(meterParamKey).set(intervalKey, item[key] ?? 0);
        }
      });
    });

    // Sort intervals chronologically
    const sortedIntervals = Array.from(uniqueIntervalsMap.entries())
      .sort((a, b) => new Date(a[1].fromDate) - new Date(b[1].fromDate))
      .map(([intervalKey, obj]) => ({ ...obj, key: intervalKey }));

    const data1 = sortedIntervals.map((d) => d.label); // x-axis
    const intervals = sortedIntervals.map((d) => ({
      label: d.label,
      fromDate: d.fromDate,
      toDate: d.toDate,
    }));

    const data2 = Array.from(seriesMap.entries()).map(([name, valuesMap]) => {
      const values = sortedIntervals.map((interval) => {
        const val = valuesMap.get(interval.key);
        return typeof val === "number" ? Math.round(val * 100) / 100 : 0;
      });
      return { name, type: "bar", data: values };
    });

    return { data1, data2, intervals };
  }

  const getResponse = (inputData) => {
    // //console.log(inputData);
    setLoadings(true)
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.ELECTRICAL_COMPARATIVE_REPORT}?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIdsorAutoID=${inputData.MeterIds}&Parameters=${inputData.Parameters}&FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}&AggregationID=${aggregationTime}`,
      // url: `${APIConstants.ELECTRICAL_COMPARATIVE_REPORT}?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&Parameters=${inputData.Parameters}&FromDate=2023-08-13 11:32:53.927&ToDate=2023-08-13 12:32:53.927`,
    }).then((res) => {
      //console.log(res);
      if (res && res.length > 0) {
        // timePeriod(res);
        const data = transformChartData(res);
        //console.log(data);
        setData(data);
        setData1(data.data1);
        setData2(data.data2);
        setLoadings(false)
      } else {
        setData([]);
      }
    });
    // .then(data => {
    //   const totalKWHTotal = data.reduce((sum, item) => sum + (item.KWHTotal || 0), 0);
    //   //console.log("Total KWHTotal:", totalKWHTotal);
    // });
  };

  const timePeriod = (data) => {
    const fromDate = new Date(fromDateString);
    const toDate = new Date(toDateString);

    const fromHours = fromDate.getUTCHours();
    const fromMinutes = fromDate.getUTCMinutes();
    const fromSeconds = fromDate.getUTCSeconds();

    const toHours = toDate.getUTCHours();
    const toMinutes = toDate.getUTCMinutes();
    const toSeconds = toDate.getUTCSeconds();

    // Set the UTC hours, minutes, and seconds
    fromDate.setUTCHours(fromHours);
    fromDate.setUTCMinutes(fromMinutes);
    fromDate.setUTCSeconds(fromSeconds);

    toDate.setUTCHours(toHours);
    toDate.setUTCMinutes(toMinutes);
    toDate.setUTCSeconds(toSeconds);

    const formattedFromDate = generatedISOFormatDateString(fromDate);
    const formattedToDate = generatedISOFormatDateString(toDate);

    const aggregationName = aggeregationResData.find(
      (aggregation) => aggregation.aggregationPeriodID === aggregationTime
    ).aggregationPeriodName;

    const period =
      aggregationName === "15Mins"
        ? "min"
        : aggregationName === "Hourly Report"
          ? "min"
          : aggregationName === "Daily Report"
            ? "day"
            : aggregationName === "Monthly Report"
              ? "month"
              : "min";

    const interval =
      aggregationName === "15Mins"
        ? 15
        : aggregationName === "Hourly Report"
          ? 60
          : aggregationName === "Daily Report"
            ? 1
            : aggregationName === "Monthly Report"
              ? 1
              : 480;

    // //console.log(data);
    // //console.log(interval);
    // //console.log(period);
    // //console.log(fromDate);
    // //console.log(toDate);
    const seriesData = groupDataByIntervalElectrical(
      data,
      interval,
      period,
      fromDate,
      toDate,
      selectedValues
    );
    // //console.log(seriesData);

    const input = seriesData?.chartArray;
    // //console.log("first");
    // //console.log(input);

    const inputArr = input;
    const dateArray = seriesData?.firstRecordCreatedONArray;
    // //console.log(dateArray);
    // //console.log(inputArr);
    const series = inputArr.map((key, index) => ({
      name: key.name,
      type: "bar",
      emphasis: {
        focus: "series",
      },
      data: key.data,
      date: dateArray,
    }));
    // //console.log(series);

    setData1(dateArray);
    setData2(series);
  };

  const validateInput = (value, label) => {
    const error = !value ? `Please Select ${label}` : "";
    return error;
  };

  const validateToDateInput = (
    toDateValue,
    fromDateValue,
    aggregationPeriod,
    label
  ) => {
    // //console.log(aggregationPeriod)
    switch (aggregationPeriod) {
      case 1: {
        // Validate if the time difference is a multiple of 15 minutes
        const timeDifferenceInMilliseconds =
          new Date(toDateValue).getTime() - new Date(fromDateValue).getTime();
        const timeDifferenceInMinutes =
          timeDifferenceInMilliseconds / (1000 * 60);

        const isMultipleOf15Minutes = timeDifferenceInMinutes % 15 === 0;
        const isAtLeast1Hour = timeDifferenceInMinutes >= 15;

        let error = "";
        if (!isMultipleOf15Minutes) {
          error = `Time difference must be a multiple of 15 minutes for ${label}`;
        } else if (!isAtLeast1Hour) {
          error = `Minimum time difference must be 15 minutes for ${label}`;
        }

        return error;
      }
      case 2: {
        // Validate if the time difference is a multiple of 60 minutes
        const timeDifferenceInMilliseconds =
          new Date(toDateValue).getTime() - new Date(fromDateValue).getTime();
        const timeDifferenceInMinutes =
          timeDifferenceInMilliseconds / (1000 * 60);

        const isMultipleOf15Minutes = timeDifferenceInMinutes % 60 === 0;
        const isAtLeast1Hour = timeDifferenceInMinutes >= 60;

        let error = "";
        if (!isMultipleOf15Minutes) {
          error = `Time difference must be a multiple of 1 hour for ${label}`;
        } else if (!isAtLeast1Hour) {
          error = `Minimum time difference must be 1 hour for ${label}`;
        }

        return error;
      }
      case 3: {
        // Validate if the time difference is a multiple of 60 minutes
        const timeDifferenceInMilliseconds =
          new Date(toDateValue).getTime() - new Date(fromDateValue).getTime();
        const timeDifferenceInMinutes =
          timeDifferenceInMilliseconds / (1000 * 60);

        const isMultipleOf15Minutes = timeDifferenceInMinutes % (60 * 24) === 0;
        const isAtLeast1Hour = timeDifferenceInMinutes >= 24 * 60;

        let error = "";
        if (!isMultipleOf15Minutes) {
          error = `Time difference must be a multiple of 1 day for ${label}`;
        } else if (!isAtLeast1Hour) {
          error = `Minimum time difference must be 1 day for ${label}`;
        }

        return error;
      }
      case 4: {
        // Validate if the time difference is a multiple of 60 minutes
        const fromDate = new Date(fromDateValue);
        const toDate = new Date(toDateValue);

        const monthsDifference =
          (toDate.getUTCFullYear() - fromDate.getUTCFullYear()) * 12 +
          (toDate.getUTCMonth() - fromDate.getUTCMonth());

        // Calculate the year and month difference

        const isMultipleOf15Minutes = monthsDifference % 1 === 0; // Check if it's a whole number of months
        const isAtLeast6Months = monthsDifference >= 1;

        let error = "";
        if (!isMultipleOf15Minutes) {
          error = `Time difference must be a multiple of 1 month for ${label}`;
        } else if (!isAtLeast6Months) {
          error = `Minimum time difference must be 1 month for ${label}`;
        }

        return error;
      }
      case 5: {
        // Validate if the time difference is a multiple of 60 minutes
        const timeDifferenceInMilliseconds =
          new Date(toDateValue).getTime() - new Date(fromDateValue).getTime();
        const timeDifferenceInMinutes =
          timeDifferenceInMilliseconds / (1000 * 60);

        const isMultipleOf15Minutes = timeDifferenceInMinutes % (60 * 24) === 0;
        const isAtLeast1Hour = timeDifferenceInMinutes >= 24 * 60;

        let error = "";
        if (!isMultipleOf15Minutes) {
          error = `Time difference must be a multiple of 1 day for ${label}`;
        } else if (!isAtLeast1Hour) {
          error = `Minimum time difference must be 1 day for ${label}`;
        }

        return error;
      }
      default: {
        // Handle invalid aggregation period
        return `Invalid aggregation period: ${aggregationPeriod}`;
      }
    }
  };

    useEffect(() => {
      handleSubmit();
    }, [defaultLoad]);
  const handleSubmit = async () => {
    const sectionError = validateInput(sectionId, "Section");
    const converterError = validateInput(converterGroupId, "Converter");
    const meterError = validateInput(selectedMeterIds?.length, "Meter");
    const paraError = validateInput(selectedValues?.length, "Parameter");
    const fromDateError = validateInput(fromDateString, "From Date");
    const toDateError = validateToDateInput(
      toDateString,
      fromDateString,
      aggregationTime,
      "From Date"
    );
    //console.log(fromDateString);
    //console.log(toDateString);
    //console.log(fromDateError);
    //console.log(toDateError);
    const aggregationError = validateInput(aggregationTime, "Aggregation");
    if (fromDateError || toDateError) {
      setDatesError("Please select a date range");
    }
    // //console.log(fromDateString)
    // //console.log(paraError)
    setSectionError(sectionError);
    setConverterError(converterError);
    setMeterError(meterError);
    setParaError(paraError);
    setFromDateError(fromDateError);
    setToDateError(toDateError);
    setAggregationError(aggregationError);

    if (
      !sectionError &&
      !converterError &&
      !meterError &&
      !paraError &&
      !fromDateError &&
      !toDateError &&
      !aggregationError &&
      !datesError
    ) {
      onClose();

      const ids = selectedMeterIds?.map((id) => id).join(",");
      const para = selectedValues?.map((id) => id).join(",");

      const fromDate = new Date(fromDateString);
      const toDate = new Date(toDateString);

      const fromHours = fromDate.getUTCHours();
      const fromMinutes = fromDate.getUTCMinutes();
      const fromSeconds = fromDate.getUTCSeconds();

      const toHours = toDate.getUTCHours();
      const toMinutes = toDate.getUTCMinutes();
      const toSeconds = toDate.getUTCSeconds();

      // Set the UTC hours, minutes, and seconds
      fromDate.setUTCHours(fromHours);
      fromDate.setUTCMinutes(fromMinutes);
      fromDate.setUTCSeconds(fromSeconds);

      toDate.setUTCHours(toHours);
      toDate.setUTCMinutes(toMinutes);
      toDate.setUTCSeconds(toSeconds);

      const formattedFromDate = generatedISOFormatDateString(fromDate);
      const formattedToDate = generatedISOFormatDateString(toDate);
      // //console.log(formattedFromDate)
         setExcelFromDate(formatDateTime(formattedFromDate))
          setExcelToDate(formatDateTime(formattedToDate))

      try {
        const inputData = {
          SectionID: Number(sectionId) || 0,
          ConverterorGroupID: Number(converterGroupId) || 0,
          MeterIds: ids || ["0"],
          Parameters: para || ["0"],
          FromDate: formattedFromDate || "2023-09-21T15:52:20.000Z",
          ToDate: formattedToDate || "2023-09-21T15:58:20.000Z",
          AggregationID: aggregationTime || "2023-09-21T15:58:20.000Z",
        };
        //console.log(inputData);

        setIsLoading(true);
        getResponse(inputData);

        // //console.log("first data");
        // //console.log(data);
        // //console.log(aggeregationResData);

        const aggregationName = aggeregationResData.find(
          (aggregation) => aggregation.aggregationPeriodID === aggregationTime
        ).aggregationPeriodName;

        const period =
          aggregationName === "15Mins"
            ? "min"
            : aggregationName === "Hourly Report"
              ? "min"
              : aggregationName === "Daily Report"
                ? "day"
                : aggregationName === "Monthly Report"
                  ? "month"
                  : "min";

        const interval =
          aggregationName === "15Mins"
            ? 15
            : aggregationName === "Hourly Report"
              ? 60
              : aggregationName === "Daily Report"
                ? 1
                : aggregationName === "Monthly Report"
                  ? 1
                  : 480;

        const seriesData = groupDataByInterval(
          data,
          interval,
          period,
          fromDate
        );

        const input = seriesData?.chartArray;

        const inputArr = input;
        const dateArray = seriesData?.firstRecordCreatedONArray;
        // //console.log(dateArray);
        // //console.log(inputArr);
        setData1([]);
        setData2([]);
      } catch (err) {
        // //console.log(err);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleTreeChange = (values) => {
    setSelectedValues(values);
    if (values.length > 4) {
      // //console.log(values);
      setParameterLenght("Cannot select more than 4 values");
    } else {
      setParameterLenght("");
    }
    if (values) {
      setParaError("");
    }
  };

  useEffect(() => {
    if (loading || !data1 || !data2) return;

    // //console.log(data1);
    // //console.log(data2);

    const myChart = echarts.init(chartRef.current);

    const option = {
      backgroundColor: isdarkMode ? "#2d3748" : "#fff",
      // title: {
      //   text: `Comparative Report`,
      //   left: 'center',
      //   top: '5px',
      //   textStyle: {
      //     color: isdarkMode ? 'white' : 'black',
      //   },
      // },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
        confine: true,
        position: function (point, params, dom, rect, size) {
          // `point` is the mouse position, `[x, y]`
          // `size` contains the size of the tooltip
          const [x, y] = point;
          const { contentSize, viewSize } = size; // Size of the tooltip and view

          let xPos = x + 10; // Add padding to the right
          let yPos = y + 10; // Add padding to the bottom

          // Prevent overflow on the right
          if (xPos + contentSize[0] > viewSize[0]) {
            xPos -= contentSize[0] + 20; // Move it left if it overflows
          }

          // Prevent overflow on the left
          if (xPos < 0) {
            xPos = 10; // Reset to a small margin on the left
          }

          // Prevent overflow at the bottom
          if (yPos + contentSize[1] > viewSize[1]) {
            yPos -= contentSize[1] + 20; // Move it up if it overflows
          }

          // Prevent overflow at the top
          if (yPos < 0) {
            yPos = 10; // Reset to a small margin at the top
          }

          return [xPos, yPos];
        },
      },

      legend: {
        bottom: "0px",
        textStyle: {
          color: isdarkMode ? "white" : "black",
        },
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "15%",
        containLabel: true,
      },
      toolbox: {
        show: true,
        orient: "horizontal",
        left: "right",
        top: "top",

        feature: {
          myExport: {
            show: true,
            title: "Export to Excel",
            icon: "path://M5 0L15 10L5 20Z", // Custom arrow-like icon
            onclick: () => {
              exportToExcel(data);
            },
          },
          mark: { show: true },
          magicType: { show: true, type: ["line", "bar"] },
          saveAsImage: { show: true },
        },
        iconStyle: {
          borderColor: isdarkMode ? "white" : "black", // Change icon color based on theme
        },
        emphasis: {
          iconStyle: {
            borderColor: isdarkMode ? "#FFD700" : "#1E90FF", // Highlighted color on hover
          },
        },
      },
      xAxis: [
        {
          type: "category",
          data: Array.from({ length: 8 }, (_, i) => `S. No.${i + 1}`),
          axisTick: { show: false },
          data: data1,
          axisLabel: {
            color: isdarkMode ? "white" : "black",
            fontSize: "10",
            rotate: 90,
            fontWeight: "bold",
          },
        },
      ],
      yAxis: [
        {
          type: "value",
          axisLabel: {
            color: isdarkMode ? "white" : "black",
            fontSize: "10",
            fontWeight: "bold",
          },
        },
      ],
      series: data2,
      dataZoom: [
        {
          type: "inside", // Enables zooming via scroll or pinch
          start: 0,
          end: 100,
        },
      ],
    };

    myChart.setOption(option);

    const resizeHandler = () => myChart.resize();
    window.addEventListener("resize", resizeHandler);

    return () => {
      window.removeEventListener("resize", resizeHandler);
      myChart.dispose();
    };
  }, [data1, data2, isdarkMode, loading, color, data]);

  // //console.log(data1);
  // //console.log(data2);

  // //console.log(loading);

  const handleTimeRangeChange = (value) => {
    const now = dayjs(); // Current time using Day.js for formatting
    let fromTime;

    switch (value) {
      case "1hour":
        fromTime = now.subtract(1, "hour");
        break;
      case "8hours":
        fromTime = now.subtract(8, "hour");
        break;
      case "7days":
        fromTime = now.subtract(7, "day");
        break;
      case "30days":
        fromTime = now.subtract(30, "day");
        break;
      case "90days":
        fromTime = now.subtract(90, "day");
        break;
      case "24hours":
        fromTime = now.subtract(1, "day");
        break;
      default:
        fromTime = null;
    }

    //console.log("From:", fromTime);
    //console.log("To:", now);
    // Format the dates into a string compatible with DatePicker
    const fromTimeString = fromTime
      ? fromTime.format("YYYY-MM-DD HH:mm:ss")
      : null;
    const toTimeString = now.format("YYYY-MM-DD HH:mm:ss");
    //console.log("From:", fromTimeString);
    //console.log("To:", toTimeString);
    // //console.log(fromTime)
    // 2024-11-08 00:00:00
    // 2024-11-20 16:05:57
    setToDateObj(null);
    setFromDateObj(null);

    // Optionally, you can return these values or set them in state
    // return { fromTimeString, toTimeString };
    //console.log(time);
    //console.log(checkedValue);
    // if(checkedValue){
    //   setFromDateString(null)
    //   setToDateString(null)
    // }else{
    setFromDateString(fromTimeString);
    setToDateString(toTimeString);
    // }
    setDatesError(null);
    setFrom(fromTimeString);
    setTo(toTimeString);
  };

  useEffect(() => {
    // setFromDateString(null);
    // setToDateString(null);
    // setValue([null,null])
    setToDateObj(null);
    setFromDateObj(null);
    setTime(false);
    setCheckedValue(null);
  }, [aggregationTime]);

  //     const exportToExcel = (data) => {
  //   // //console.log(data);
  //   // //console.log(shift);

  //   const roundToTwo = (num) => Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100;

  //   if (shift === "24hours") {
  //     const headers = ["Meter", "Time", "Shift Value", "Parameter"];
  //     const rows = [];
  //     let totalEnergy = 0;

  //     data.forEach((item, meterIndex) => {
  //       const meterName = item.name || `Meter ${meterIndex + 1}`;

  //       item.data.forEach((entry) => {
  //         const fromDate = new Date(entry.intervalRange?.start);
  //         const toDate = new Date(entry.intervalRange?.end);

  //         const formattedFromDate = fromDate.toLocaleString("en-GB", {
  //           day: "2-digit", month: "2-digit", year: "numeric",
  //           hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true,
  //         });

  //         const formattedToDate = toDate.toLocaleString("en-GB", {
  //           day: "2-digit", month: "2-digit", year: "numeric",
  //           hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true,
  //         });

  //         const timeRange = `From: ${formattedFromDate} To: ${formattedToDate}`;
  //         const value = parseFloat(entry.value || 0);
  //         totalEnergy += value;

  //         rows.push([
  //           meterName,
  //           timeRange,
  //           roundToTwo(value),
  //           selectedValues?.toString() || "",
  //         ]);
  //       });
  //     });

  //     // Add total row with rounded total
  //     rows.push([
  //       "Total",
  //       "",
  //       roundToTwo(totalEnergy),
  //       "",
  //     ]);

  //     const excelData = [headers, ...rows];

  //     const workbook = XLSX.utils.book_new();
  //     const worksheet = XLSX.utils.aoa_to_sheet(excelData);
  //     XLSX.utils.book_append_sheet(workbook, worksheet, "EnergyData");

  //     const now = new Date();
  //     const timestamp = now.toLocaleString("en-US", {
  //       year: "numeric", month: "2-digit", day: "2-digit",
  //       hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false,
  //     }).replace(/[/,: ]/g, "-");

  //     const filename = `Comparative_Report_${timestamp}.xlsx`;
  //     XLSX.writeFile(workbook, filename);
  //   }

  //   // ELSE block for non-24-hour shift
  //   else {
  //     if (typeof XLSX === "undefined") {
  //       throw new Error("SheetJS (XLSX) library is required for this function.");
  //     }

  //     const formatDate = (date) => {
  //       return new Date(date)
  //       .toLocaleString("en-GB", {
  //         year: "numeric", month: "2-digit", day: "2-digit",
  //         hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true,
  //       });
  //     };

  //     const meterNames = data.map((item) => item.name);
  //     const rowCount = data[0]?.data?.length || 0;
  //     const headers = ["From Date", "To Date", ...meterNames, "Parameter"];
  //     const rows = [headers];
  //     const totals = {};
  //     meterNames.forEach((name) => (totals[name] = 0));

  //     for (let i = 0; i < rowCount; i++) {
  //       const intervalStart = data[0].data[i].intervalRange?.start;
  //       const intervalEnd = data[0].data[i].intervalRange?.end;

  //       const row = [
  //         formatDate(intervalStart),
  //         formatDate(intervalEnd),
  //       ];

  //       data.forEach((meter) => {
  //         const value = parseFloat(meter.data[i]?.value || 0);
  //         row.push(roundToTwo(value));
  //         totals[meter.name] += value;
  //       });

  //       row.push(selectedValues?.toString() || "");
  //       rows.push(row);
  //     }

  //     const totalRow = [
  //       "Total",
  //       "",
  //       ...meterNames.map((name) => roundToTwo(totals[name])),
  //       "",
  //     ];
  //     rows.push(totalRow);

  //     const workbook = XLSX.utils.book_new();
  //     const worksheet = XLSX.utils.aoa_to_sheet(rows);
  //     XLSX.utils.book_append_sheet(workbook, worksheet, "Interval Report");

  //     const now = new Date();
  //     const timestamp = now.toISOString().replace(/[-:T]/g, "_").split(".")[0];
  //     const filename = `Comparative_Report_${timestamp}.xlsx`;

  //     XLSX.writeFile(workbook, filename);
  //   }
  // };
  const dumy = 0;
  // const exportToExcel = (input) => {
  //   const { data1, data2, intervals } = input;

  //   const roundToTwo = (num) =>
  //     Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100;

  //   // Fix for 'DD/MM/YYYY HH:mm:ss' date strings
  //   const parseCustomDate = (str) => {
  //     const [datePart, timePart] = str.split(" ");
  //     const [day, month, year] = datePart.split("/").map(Number);
  //     const [hour, minute, second] = timePart.split(":").map(Number);
  //     return new Date(year, month - 1, day, hour, minute, second);
  //   };

  //   const is24HourShift = shift === "24hours";

  //   if (is24HourShift) {
  //     const headers = ["Meter", "Time", "Shift Value", "Parameter"];
  //     const rows = [];
  //     let totalEnergy = 0;

  //     data2.forEach((meter, meterIndex) => {
  //       const meterName = meter.name || `Meter ${meterIndex + 1}`;
  //       meter.data.forEach((value, index) => {
  //         const interval = intervals[index];
  //         const fromDate = parseCustomDate(interval?.fromDate);
  //         const toDate = parseCustomDate(interval?.toDate);

  //         const formattedFromDate = fromDate.toLocaleString("en-GB", {
  //           day: "2-digit",
  //           month: "2-digit",
  //           year: "numeric",
  //           hour: "2-digit",
  //           minute: "2-digit",
  //           second: "2-digit",
  //           hour12: true,
  //         });

  //         const formattedToDate = toDate.toLocaleString("en-GB", {
  //           day: "2-digit",
  //           month: "2-digit",
  //           year: "numeric",
  //           hour: "2-digit",
  //           minute: "2-digit",
  //           second: "2-digit",
  //           hour12: true,
  //         });

  //         const timeRange = `From: ${formattedFromDate} To: ${formattedToDate}`;
  //         const roundedValue = roundToTwo(value);
  //         totalEnergy += roundedValue;

  //         rows.push([
  //           meterName,
  //           timeRange,
  //           roundedValue,
  //           selectedValues?.toString() || "",
  //         ]);
  //       });
  //     });

  //     rows.push(["Total", "", roundToTwo(totalEnergy), ""]);

  //     const excelData = [headers, ...rows];

  //     const workbook = XLSX.utils.book_new();
  //     const worksheet = XLSX.utils.aoa_to_sheet(excelData);
  //     XLSX.utils.book_append_sheet(workbook, worksheet, "EnergyData");

  //     const now = new Date();
  //     const timestamp = now
  //       .toLocaleString("en-US", {
  //         year: "numeric",
  //         month: "2-digit",
  //         day: "2-digit",
  //         hour: "2-digit",
  //         minute: "2-digit",
  //         second: "2-digit",
  //         hour12: false,
  //       })
  //       .replace(/[/,: ]/g, "-");

  //     const filename = `Comparative_Report_${timestamp}.xlsx`;
  //     XLSX.writeFile(workbook, filename);
  //   } else {
  //     if (typeof XLSX === "undefined") {
  //       throw new Error("SheetJS (XLSX) library is required for this function.");
  //     }

  //     const formatDate = (str) =>
  //       parseCustomDate(str).toLocaleString("en-GB", {
  //         year: "numeric",
  //         month: "2-digit",
  //         day: "2-digit",
  //         hour: "2-digit",
  //         minute: "2-digit",
  //         second: "2-digit",
  //         hour12: true,
  //       });

  //     const meterNames = data2.map((d) => d.name);
  //     const headers = ["From Date", "To Date", ...meterNames, "Parameter"];
  //     const rows = [headers];

  //     const totals = {};
  //     meterNames.forEach((name) => (totals[name] = 0));

  //     intervals.forEach((interval, index) => {
  //       const row = [
  //         formatDate(interval.fromDate),
  //         formatDate(interval.toDate),
  //       ];

  //       data2.forEach((meter) => {
  //         const value = parseFloat(meter.data[index] || 0);
  //         const rounded = roundToTwo(value);
  //         row.push(rounded);
  //         totals[meter.name] += rounded;
  //       });

  //       row.push(selectedValues?.toString() || "");
  //       rows.push(row);
  //     });

  //     const totalRow = [
  //       "Total",
  //       "",
  //       ...meterNames.map((name) => roundToTwo(totals[name])),
  //       "",
  //     ];
  //     rows.push(totalRow);

  //     const workbook = XLSX.utils.book_new();
  //     const worksheet = XLSX.utils.aoa_to_sheet(rows);
  //     XLSX.utils.book_append_sheet(workbook, worksheet, "Interval Report");

  //     const now = new Date();
  //     const timestamp = now.toISOString().replace(/[-:T]/g, "_").split(".")[0];
  //     const filename = `Comparative_Report_${timestamp}.xlsx`;

  //     XLSX.writeFile(workbook, filename);
  //   }
  // };

  const getImageBufferFromUrl = async (url) => {
    const response = await fetch(url);
    return await response.arrayBuffer();
  };

  // const exportToExcel = async (input) => {
  //   const { data1, data2, intervals } = input;

  //   const roundToTwo = (num) =>
  //     Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100;

  //   const parseCustomDate = (str) => {
  //     const [datePart, timePart] = str.split(" ");
  //     const [day, month, year] = datePart.split("/").map(Number);
  //     const [hour, minute, second] = timePart.split(":").map(Number);
  //     return new Date(year, month - 1, day, hour, minute, second);
  //   };

  //   const is24HourShift = shift === "24hours";

  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet("Report");

  //   // Add logo
  //   worksheet.mergeCells("A1:D2"); // Merge cells for logo
  //   const logoBuffer = await getImageBufferFromUrl(minnotra_logo); // Define `minnotra_logo` as image URL
  //   const imageId = workbook.addImage({
  //     buffer: logoBuffer,
  //     extension: "png",
  //   });
  //   worksheet.addImage(imageId, {
  //     tl: { col: 0.2, row: 0.1 },
  //     ext: { width: 120, height: 30 },
  //   });

  //   const startingRow = 4;
  //   let headerRowData = [];
  //   const rows = [];

  //   if (is24HourShift) {
  //     headerRowData = ["Meter", "Time", "Shift Value", "Parameter"];
  //     let totalEnergy = 0;

  //     data2.forEach((meter, meterIndex) => {
  //       const meterName = meter.name || `Meter ${meterIndex + 1}`;
  //       meter.data.forEach((value, index) => {
  //         const interval = intervals[index];
  //         const fromDate = parseCustomDate(interval?.fromDate);
  //         const toDate = parseCustomDate(interval?.toDate);

  //         const formattedFromDate = fromDate.toLocaleString("en-GB", {
  //           day: "2-digit",
  //           month: "2-digit",
  //           year: "numeric",
  //           hour: "2-digit",
  //           minute: "2-digit",
  //           second: "2-digit",
  //           hour12: true,
  //         });

  //         const formattedToDate = toDate.toLocaleString("en-GB", {
  //           day: "2-digit",
  //           month: "2-digit",
  //           year: "numeric",
  //           hour: "2-digit",
  //           minute: "2-digit",
  //           second: "2-digit",
  //           hour12: true,
  //         });

  //         const timeRange = `From: ${formattedFromDate} To: ${formattedToDate}`;
  //         const roundedValue = roundToTwo(value);
  //         totalEnergy += roundedValue;

  //         rows.push([
  //           meterName,
  //           timeRange,
  //           roundedValue,
  //           selectedValues?.toString() || "",
  //         ]);
  //       });
  //     });

  //     rows.push(["Total", "", roundToTwo(totalEnergy), ""]);
  //   } else {
  //     const formatDate = (str) =>
  //       parseCustomDate(str).toLocaleString("en-GB", {
  //         year: "numeric",
  //         month: "2-digit",
  //         day: "2-digit",
  //         hour: "2-digit",
  //         minute: "2-digit",
  //         second: "2-digit",
  //         hour12: true,
  //       });

  //     const meterNames = data2.map((d) => d.name);
  //     headerRowData = ["From Date", "To Date", ...meterNames, "Parameter"];

  //     const totals = {};
  //     meterNames.forEach((name) => (totals[name] = 0));

  //     intervals.forEach((interval, index) => {
  //       const row = [
  //         formatDate(interval.fromDate),
  //         formatDate(interval.toDate),
  //       ];

  //       data2.forEach((meter) => {
  //         const value = parseFloat(meter.data[index] || 0);
  //         const rounded = roundToTwo(value);
  //         row.push(rounded);
  //         totals[meter.name] += rounded;
  //       });

  //       row.push(selectedValues?.toString() || "");
  //       rows.push(row);
  //     });

  //     const totalRow = [
  //       "Total",
  //       "",
  //       ...meterNames.map((name) => roundToTwo(totals[name])),
  //       "",
  //     ];
  //     rows.push(totalRow);
  //   }

  //   // Add styled header
  //   const headerRow = worksheet.getRow(startingRow);
  //   headerRow.values = headerRowData;
  //   headerRow.eachCell((cell) => {
  //     cell.fill = {
  //       type: "pattern",
  //       pattern: "solid",
  //       fgColor: { argb: "FF00B050" },
  //     };
  //     cell.font = {
  //       bold: true,
  //       color: { argb: "FFFFFFFF" },
  //     };
  //     cell.alignment = { vertical: "middle", horizontal: "center" };
  //     cell.border = {
  //       top: { style: "thin" },
  //       left: { style: "thin" },
  //       bottom: { style: "thin" },
  //       right: { style: "thin" },
  //     };
  //   });

  //   // Add data rows below header
  //   rows.forEach((rowData, i) => {
  //     const row = worksheet.getRow(startingRow + 1 + i);
  //     row.values = rowData;
  //     row.eachCell((cell) => {
  //       cell.border = {
  //         top: { style: "thin" },
  //         left: { style: "thin" },
  //         bottom: { style: "thin" },
  //         right: { style: "thin" },
  //       };
  //     });
  //   });

  //   // Save file
  //   const now = new Date();
  //   const timestamp = now.toISOString().replace(/[-:T]/g, "_").split(".")[0];
  //   const filename = `Comparative_Report_${timestamp}.xlsx`;
  //   const buffer = await workbook.xlsx.writeBuffer();
  //   saveAs(new Blob([buffer]), filename);
  // };

  const exportToExcelfine = async (input) => {
  const { data1, data2, intervals } = input;

  const roundToTwo = (num) =>
    Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100;

  const parseCustomDate = (str) => {
    const [datePart, timePart] = str.split(" ");
    const [day, month, year] = datePart.split("/").map(Number);
    const [hour, minute, second] = timePart.split(":").map(Number);
    return new Date(year, month - 1, day, hour, minute, second);
  };

  const is24HourShift = shift === "24hours";

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Report");

  // Add logo
  worksheet.mergeCells("A1:D2");
  const logoBuffer = await getImageBufferFromUrl(minnotra_logo);
  const imageId = workbook.addImage({
    buffer: logoBuffer,
    extension: "png",
  });
  worksheet.addImage(imageId, {
    tl: { col: 0.2, row: 0.1 },
    ext: { width: 120, height: 30 },
  });

  const startingRow = 4;
  let headerRowData = [];
  const rows = [];

  if (is24HourShift) {
    headerRowData = ["Meter", "Time", "Shift Value", "Parameter"];
    let totalEnergy = 0;

    data2.forEach((meter, meterIndex) => {
      const meterName = meter.name || `Meter ${meterIndex + 1}`;
      meter.data.forEach((value, index) => {
        const interval = intervals[index];
        const fromDate = parseCustomDate(interval?.fromDate);
        const toDate = parseCustomDate(interval?.toDate);

        const formattedFromDate = fromDate.toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        });

        const formattedToDate = toDate.toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        });

        const timeRange = `From: ${formattedFromDate} To: ${formattedToDate}`;
        const roundedValue = roundToTwo(value);
        totalEnergy += roundedValue;

        rows.push([
          meterName,
          timeRange,
          roundedValue,
          selectedValues?.toString() || "",
        ]);
      });
    });

    rows.push(["Total", "", roundToTwo(totalEnergy), ""]);
  } else {
    const formatDate = (str) =>
      parseCustomDate(str).toLocaleString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });

    const meterNames = data2.map((d) => d.name);
    headerRowData = ["From Date", "To Date", ...meterNames, "Parameter"];

    const totals = {};
    meterNames.forEach((name) => (totals[name] = 0));

    intervals.forEach((interval, index) => {
      const row = [
        formatDate(interval.fromDate),
        formatDate(interval.toDate),
      ];

      data2.forEach((meter) => {
        const value = parseFloat(meter.data[index] || 0);
        const rounded = roundToTwo(value);
        row.push(rounded);
        totals[meter.name] += rounded;
      });

      row.push(selectedValues?.toString() || "");
      rows.push(row);
    });

    const totalRow = [
      "Total",
      "",
      ...meterNames.map((name) => roundToTwo(totals[name])),
      "",
    ];
    rows.push(totalRow);
  }

  // Add styled header
  const headerRow = worksheet.getRow(startingRow);
  headerRow.values = headerRowData;
  headerRow.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF00B050" },
    };
    cell.font = {
      bold: true,
      color: { argb: "FFFFFFFF" },
    };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // Add data rows
  rows.forEach((rowData, i) => {
    const row = worksheet.getRow(startingRow + 1 + i);
    row.values = rowData;
    row.eachCell((cell) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
  });

  // ✅ Auto-fit column widths (header + data)
  headerRowData.forEach((h, i) => {
    const col = worksheet.getColumn(i + 1);
    let maxLength = h ? h.toString().length : 10;

    col.eachCell({ includeEmpty: true }, (cell) => {
      const val = cell.value ? cell.value.toString() : "";
      if (val.length > maxLength) maxLength = val.length;
    });

    col.width = Math.min(Math.max(maxLength + 2, 12), 50);
  });

  // ✅ Highlight last row if it's "Total"
  const lastRow = worksheet.getRow(startingRow + rows.length);
  if (lastRow.getCell(1).value === "Total") {
    lastRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FF000000" } };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFD9D9D9" }, // light gray
      };
    });
  }

  // Save file
  const now = new Date();
  const timestamp = now.toISOString().replace(/[-:T]/g, "_").split(".")[0];
  const filename = `Comparative_Report_${timestamp}.xlsx`;
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), filename);
};
const exportToExcel = async (input) => {
  const formattedFromDate=excelFromDate;
  const formattedToDate= excelToDate
  // excelFromDate,excelToDate
  const { data1, data2, intervals } = input;

  const roundToTwo = (num) =>
    Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100;

  const parseCustomDate = (str) => {
    const [datePart, timePart] = str.split(" ");
    const [day, month, year] = datePart.split("/").map(Number);
    const [hour, minute, second] = timePart.split(":").map(Number);
    return new Date(year, month - 1, day, hour, minute, second);
  };

  const is24HourShift = shift === "24hours";

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Report");

  // ✅ Step 1: Add Logo
  worksheet.mergeCells("A1:D2");
  const logoBuffer = await excelImage? getImageBufferFromUrl(excelImage):getImageBufferFromUrl(minnotra_logo);
  const imageId = workbook.addImage({
    buffer: logoBuffer,
    extension: "png",
  });
  worksheet.addImage(imageId, {
    tl: { col: 0.2, row: 0.1 },
    ext: { width: 120, height: 38 },
  });

  // ✅ Step 2: Add Title "Comparative Report"
  worksheet.mergeCells("A3:D3");
  const titleCell = worksheet.getCell("A3");
  titleCell.value = "Comparative Report";
  titleCell.font = { bold: true, size: 14 };
  titleCell.alignment = { horizontal: "center", vertical: "middle" };

  // ✅ Step 3: Add From & To Date below title
  worksheet.mergeCells("A4:D4");
  const dateCell = worksheet.getCell("A4");
  dateCell.value = `From: ${formattedFromDate}   To: ${formattedToDate}`;
  dateCell.font = { bold: true, size: 11 };
  dateCell.alignment = { horizontal: "left", vertical: "middle" };

  // ✅ Data Table starts after line 6
  const startingRow = 6;
  let headerRowData = [];
  const rows = [];

  if (is24HourShift) {
    headerRowData = ["Meter", "Time", "Shift Value", "Parameter"];
    let totalEnergy = 0;

    data2.forEach((meter, meterIndex) => {
      const meterName = meter.name || `Meter ${meterIndex + 1}`;
      meter.data.forEach((value, index) => {
        const interval = intervals[index];
        const fromDate = parseCustomDate(interval?.fromDate);
        const toDate = parseCustomDate(interval?.toDate);

        const formattedFromDate = fromDate.toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        });

        const formattedToDate = toDate.toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        });

        const timeRange = `From: ${formattedFromDate} To: ${formattedToDate}`;
        const roundedValue = roundToTwo(value);
        totalEnergy += roundedValue;

        rows.push([
          meterName,
          timeRange,
          roundedValue,
          selectedValues?.toString() || "",
        ]);
      });
    });

    rows.push(["Total", "", roundToTwo(totalEnergy), ""]);
  } else {
    const formatDate = (str) =>
      parseCustomDate(str).toLocaleString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });

    const meterNames = data2.map((d) => d.name);
    headerRowData = ["From Date", "To Date", ...meterNames, "Parameter"];

    const totals = {};
    meterNames.forEach((name) => (totals[name] = 0));

    intervals.forEach((interval, index) => {
      const row = [
        formatDate(interval.fromDate),
        formatDate(interval.toDate),
      ];

      data2.forEach((meter) => {
        const value = parseFloat(meter.data[index] || 0);
        const rounded = roundToTwo(value);
        row.push(rounded);
        totals[meter.name] += rounded;
      });

      row.push(selectedValues?.toString() || "");
      rows.push(row);
    });

    const totalRow = [
      "Total",
      "",
      ...meterNames.map((name) => roundToTwo(totals[name])),
      "",
    ];
    rows.push(totalRow);
  }

  // ✅ Step 4: Add styled table header
  const headerRow = worksheet.getRow(startingRow);
  headerRow.values = headerRowData;
  headerRow.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF00B050" },
    };
    cell.font = {
      bold: true,
      color: { argb: "FFFFFFFF" },
    };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // ✅ Step 5: Add data rows
  rows.forEach((rowData, i) => {
    const row = worksheet.getRow(startingRow + 1 + i);
    row.values = rowData;
    row.eachCell((cell) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
  });

  // ✅ Step 6: Auto-fit columns
  headerRowData.forEach((h, i) => {
    const col = worksheet.getColumn(i + 1);
    let maxLength = h ? h.toString().length : 10;

    col.eachCell({ includeEmpty: true }, (cell) => {
      const val = cell.value ? cell.value.toString() : "";
      if (val.length > maxLength) maxLength = val.length;
    });

    col.width = Math.min(Math.max(maxLength + 2, 12), 50);
  });

  // ✅ Step 7: Highlight last row if "Total"
  const lastRow = worksheet.getRow(startingRow + rows.length);
  if (lastRow.getCell(1).value === "Total") {
    lastRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FF000000" } };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFD9D9D9" },
      };
    });
  }

  // ✅ Step 8: Save file
  const now = new Date();
  const timestamp = now.toISOString().replace(/[-:T]/g, "_").split(".")[0];
  const filename = `Comparative_Report_${timestamp}.xlsx`;
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), filename);
};


  const handleCheckboxChange = (checked, value) => {
    setCheckedValue(checked ? value : null);
    setTime(!time);
    // //console.log(checked);
    // //console.log(value);

    if (checked) {
      setShift(value);
      handleTimeRangeChange(value);
    } else {
      setFromDateString(null);
      setToDateString(null);
    }
    //console.log("Checked value:", checked ? value : "None");
  };

  const aggregationMap = {
    1: { value: "1hour", label: "Last 1 Hour" },
    2: { value: "8hours", label: "Last 8 Hours" },
    3: { value: "7days", label: "Last 7 Days" },
    4: { value: "30days", label: "Last 30 Days" },
    4: { value: "90days", label: "Last 90 Days" },
    5: { value: "24hours", label: "Last 24 Hours" },
  };
  // //console.log(checkedValue);
  // //console.log(time);
  // //console.log(data1);

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--date-ok-btn",
      color.themeConfig.colorPrimary
    );
    document.documentElement.style.setProperty("--date-now-btn", "#fff");
  }, [color]);

  const [showCalendar, setShowCalendar] = useState(false);
  //  const [value, setValue] = useState([null,null]);

  const today = dayjs();

  const startOfWeek = dayjs().startOf("week").startOf("day"); // Sunday 12:00 AM
  const endOfWeek = dayjs().endOf("week").startOf("day"); // Saturday 12:00 AM

  const startOfLastWeek = dayjs()
    .subtract(1, "week")
    .startOf("week")
    .startOf("day"); // Previous Sunday 12:00 AM
  const endOfLastWeek = dayjs()
    .subtract(1, "week")
    .endOf("week")
    .startOf("day"); // Previous Saturday 12:00 AM

  const startOfMonth = dayjs().startOf("month").startOf("day"); // 1st of this month 12:00 AM
  const endOfMonth = dayjs().endOf("month").startOf("day"); // Last of this month 12:00 AM

  const startOfLastMonth = dayjs()
    .subtract(1, "month")
    .startOf("month")
    .startOf("day");
  const endOfLastMonth = dayjs()
    .subtract(1, "month")
    .endOf("month")
    .startOf("day");

  const rangePresets = [
        { label: "Yesterday", value: [today.subtract(1, "day").startOf("day"), today.startOf("day")] },
    { label: "This Week", value: [startOfWeek, endOfWeek] },
    { label: "Last Week", value: [startOfLastWeek, endOfLastWeek] },
    { label: "This Month", value: [startOfMonth, endOfMonth] },
    { label: "Last Month", value: [startOfLastMonth, endOfLastMonth] },
    {
      label: "Last 7 Days",
      value: [dayjs().subtract(7, "day").startOf("day"), today.startOf("day")],
    },
    {
      label: "Last 15 Days",
      value: [dayjs().subtract(15, "day").startOf("day"), today.startOf("day")],
    },
    {
      label: "Last 30 Days",
      value: [dayjs().subtract(30, "day").startOf("day"), today.startOf("day")],
    },
    {
      label: "Last 90 Days",
      value: [dayjs().subtract(90, "day").startOf("day"), today.startOf("day")],
    },
  ];

  // const handleDateChange = (value) => {
  //   if (!value) return;
  //   const diff = value[1]?.diff(value[0], "day");

  //   if (diff > MAX_DAYS) {
  //     alert("Date range cannot exceed 90 days");
  //     return;
  //   }

  //   if (value) {
  //     // const fromDate = value[0];
  //     // const toDate = value[1];
  //     const fromDate = value[0]?.format("YYYY-MM-DD HH:mm:ss");
  //     const toDate = value[1]?.format("YYYY-MM-DD HH:mm:ss");

  //     //console.log([fromDate, toDate]);
  //     setValue([value[0], value[1]]);
  //     onChangeFromDate(fromDate);
  //     onChangeToDate(toDate);
  //   } else {
  //     // setDates(null);
  //   }
  // };

  const handleDateChange = (value) => {
    // if (!value) return;
    // const diff = value[1]?.diff(value[0], "day");

    // if (diff > MAX_DAYS) {
    //   alert("Date range cannot exceed 90 days");
    //   return;
    // }

    if (value) {
      // const fromDate = value[0];
      // const toDate = value[1];
      const fromDate = value[0]?.format("YYYY-MM-DD HH:mm:ss");
      const toDate = value[1]?.format("YYYY-MM-DD HH:mm:ss");
      if (!fromDate && !toDate) {
        setDatesError("Please select a date range");
      } else {
        setDatesError(null);
      }

      // //console.log([fromDate, toDate]);
      setValue([value[0], value[1]]);
      onChangeFromDate(fromDate);
      onChangeToDate(toDate);
    } else {
      setDatesError("Please select a date range");
    }
  };

  // //console.log(isdarkMode)
  useEffect(()=>{
    if(checkedValue){
      setValue([null,null])
    }
  },[checkedValue])

  return (
    <div
      id="chart"
      className={` relative bg-white p-4 rounded-md  dark ${isdarkMode ? "darkmode" : "whitemode"} `}
    >
      {/* {
          data1.length ==0 && !loadings && !loading &&
             <h4 className={`text-center text-[20px] mb-5 dark ${isdarkMode ? 'darkfont' : 'whitemode'}`}>COMPARATIVE REPORT</h4> 
         } */}

      <div className="flex justify-between items-center px-0 pb-3">
        <div className="text-3xl">
          <h4
            className={`text-center mb-0 dark ${isdarkMode ? "darkfont" : "whitemode"}`}
          >
            COMPARATIVE REPORT
          </h4>
        </div>
        <Button
          role="primary"
          size="large"
          className="flex justify-center items-center secondary-btn"
          style={{
            "--secondary-color": color.themeConfig.secondaryColor,
            "--primary-color": color.themeConfig.colorPrimary,
          }}
          onClick={() => setOpen(!open)}
        >
          <FilterOutlined /> Filter
        </Button>
      </div> 
      {
        data1.length == 0 && !loading&&!loadings && (
          <Empty open={open} setOpen={setOpen} isdarkMode={isdarkMode} />
        )
        // <div className="text-3xl">
        // <div className={`${!isdarkMode ? "text-black" : "text-white"}`}>No Data Available</div>
        // </div>
      }
      {/* {
        data1.length == 0 && !loadings && (
          <Empty open={open} setOpen={setOpen} isdarkMode={isdarkMode} />
        )
        // <div className="text-3xl">
        // <div className={`${!isdarkMode ? "text-black" : "text-white"}`}>No Data Available</div>
        // </div>
      } */}
        {loadings && (
          <>
            <Skeleton active paragraph={{ rows: 6 }} />
          </>
        )}
      <Card
        className={`p-5 rounded-md dark border  ${ !loadings && !loading && data1.length > 0 ? "" : "hidden"} ${isdarkMode ? "darkmode " : `whitemode `} w-full lg:w-full md:w-11/12 sm:w-10/12 xs:w-11/12`}
        // style={{ position: "relative", overflow: "hidden", background:isdarkMode ? "" : color.themeConfig.colorPrimaryShade }}
        bordered={false}
      >

        <div
          ref={chartRef}
          className={`${(!loading || !loadings) && data1.length > 0 ? "min-h-[80vh]" : "h-0"}  w-[100%]  mx-auto rounded-lg  mb-0 md:mb-0 px-3`}
        />
      </Card>
      <CustomDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col space-y-2">
          <CustomSelect
            label="Section:"
            options={getFlowSectionList}
            onSelect={handleChangeSection}
            valueKey="sectionID"
            nameKey="sectionName"
            selectedValues={sectionId}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {sectionError}
          </small>
          <CustomSelect
            label="Converter / Group:"
            options={
              sectionId === 1 ? getFlowConverterList : flowGroupDetailsList
            }
            onSelect={handleChangeConverterGroup}
            // valueKey={sectionId === 1 ? "sitE_ID" : "groupID"}
            // nameKey={sectionId === 1 ? "sitename" : "department"}
            valueKey={sectionId === 1 ? "siteID" : "groupID"}
            nameKey={sectionId === 1 ? "siteName" : "department"}
            selectedValues={converterGroupId}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {converterError}
          </small>
          <TreeSelectCustomWithSelectAll
            label="Meters:"
            data={
              sectionId === 1
                ? nsGetFlowConverterList
                : getFlowSteamGroupMeterList
            }
            idKey={sectionId === 1 ? "meterid" : "meterid"}
            valueKey={sectionId === 1 ? "meterid" : "meterid"}
            nameKey={sectionId === 1 ? "metername" : "metername"}
            selectedValues={selectedMeterIds}
            setSelectedValues={setSelectedMeterIds}
            onSelect={handleMeterChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {meterError}
          </small>
          <SteamTreeSelectCustomWithSelectAll
            label="Parameters:"
            data={parameter}
            idKey="parameterid"
            nameKey="parametername"
            valueKey="parametername"
            selectedValues={selectedValues}
            onSelect={handleTreeChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {paraError}
            {/* {parameterLenght} */}
          </small>
          <CustomSelect
            label="Aggregation period:"
            options={aggeregationList}
            onSelect={handleChangeAggregation}
            valueKey="aggregationPeriodID"
            nameKey="aggregationPeriodName"
            selectedValues={aggregationTime}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {aggregationError}
          </small>
          <div className="mt-2 flex flex-col">
            {aggregationMap[aggregationTime] && (
              <div
                className={`custom-checkbox ml-[130px] ${isdarkMode ? "dark-theme" : "light-theme"} `}
              >
                <Checkbox
                  checked={
                    checkedValue === aggregationMap[aggregationTime].value
                  }
                  defaultChecked
                  onChange={(e) =>
                    handleCheckboxChange(
                      e.target.checked,
                      aggregationMap[aggregationTime].value
                    )
                  }
                >
                  {/* <p className={`${isdarkMode ? 'text-white' : 'text-black'}`}> */}
                  {aggregationMap[aggregationTime].label}
                  {/* </p> */}
                </Checkbox>
              </div>
            )}
            {/* <small className="text-red-500 font-bold ml-[150px] w-full">
              {toDateError}
            </small> */}
          </div>

          {!time && !checkedValue ? (
            <>
              <div className="mt-2 flex">
                <label className="pr-3 w-32 text-left">Date:</label>

                <RangePicker
                  value={value}
                  onChange={handleDateChange}
                  popupClassName="custom-picker"
                  presets={rangePresets}
                  format="YYYY-MM-DD HH:mm:ss"
                  showTime={{ format: "HH:mm:ss" }}
                  className={`w-80 ml-0 shadow-lg rounded-3xl  ${
                    isdarkMode
                      ? "customRangePicker-dark  text-white"
                      : "customRangePicker-light text-black"
                  }`}
                  panelRender={(originalPanel) => {
                    if (!showCalendar) {
                      return (
                        <div
                          className={`${
                            isdarkMode ? "bg-[#1a1a1a]" : "bg-white"
                          } flex flex-col gap-1 p-2 w-44 rounded`}
                        >
                          {rangePresets.map((preset) => (
                            <div
                              key={preset.label}
                              onClick={() => handleDateChange(preset.value)}
                              className={`cursor-pointer px-2 py-1 rounded ${
                                isdarkMode
                                  ? "text-white hover:bg-gray-700"
                                  : "text-black hover:bg-gray-200"
                              }`}
                            >
                              {preset.label}
                            </div>
                          ))}
                          <button
                            onClick={() => setShowCalendar(true)}
                            className={`mt-2 px-2 py-1 rounded  border text-center ${
                              isdarkMode
                                ? "bg-[#1a1a1a] border-white text-white hover:bg-gray-700"
                                : "bg-white border-black text-black hover:bg-gray-200"
                            }`}
                          >
                            Custom Dates
                          </button>
                        </div>
                      );
                    }
                    return originalPanel;
                  }}
                  onOpenChange={(open) => {
                    if (!open) setShowCalendar(false);
                  }}
                />
              </div>
              <small className="text-red-500 font-bold ml-[150px]">
                {fromDateError || toDateError || datesError}
              </small>
            </>
          ) : (
            ""
          )}
        </div>
        <div className="flex justify-center mt-4">
          <Button
            type={isdarkMode ? "" : "primary"}
            onClick={() => {
              handleSubmit();
            }}
          >
            Search
          </Button>
        </div>
      </CustomDrawer>
      <style>
        {`
          .custom-picker .ant-picker-ok .ant-btn{
            background-color: var(--date-ok-btn) !important;
            border-color: var(--date-ok-btn) !important;
            color: white !important;
          }
          .custom-picker .ant-picker-ok .ant-btn:hover {
            background-color: var(--date-ok-btn) !important;
            border-color: #d9363e !important;
          }
          .custom-picker .ant-picker-now .ant-picker-now-btn {
            color: var(--date-ok-btn) !important;
          }
          .custom-picker .anticon-swap-right, .anticon-calendar{
            // background-color: red !important;
            color: var(--date-ok-btn) !important;
          }
        `}
      </style>
    </div>
  );
};

export default ComparitiveReport;
